import { CssSpinner } from "src/main";
import { SaveIcon } from "./assets/SaveIcon";
import s from "./ReportSaveTemplateButton.module.scss";

interface IProps {
  onExport: () => void;
  loading: boolean;
}
export const ReportSaveTemplateButton = ({ onExport, loading }: IProps) => {
  return (
    <div onClick={onExport} className={s.left}>
      {loading ? (
        <div className={s.spinner} />
      ) : (
        <>
          <SaveIcon />
          <span>Save Template to account</span>
        </>
      )}
    </div>
  );
};
